import { render, staticRenderFns } from "./MapSettings.vue?vue&type=template&id=16363e6d&"
import script from "./MapSettings.vue?vue&type=script&lang=js&"
export * from "./MapSettings.vue?vue&type=script&lang=js&"
import style0 from "./MapSettings.vue?vue&type=style&index=0&id=16363e6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports